module.exports = __webpack_public_path__ + "img/ferencva-türosi-clogo.28cef1c9.png";